
export const useWordFontSize = (): number => {
  return 24;
};
